import styled from "styled-components";
import PermissionCheck from "../../../Common/PermissionCheck";
import { QuickLinkComponent } from "../../../Common/QuickLink";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import usePermissionsByCompetitionName from "../../../hooks/usePermissionsByCompetitionName";
import AddPersonModal from "../../Person/AddPersonModal";
import SeasonsList from "../../Season/SeasonList";
import AddTeam from "../../Team/AddTeam";
import AddVenue from "../../Venues/AddVenue";

const Dashboard = () => {
  const { entityPermissionName } = usePermissionsByCompetitionName();

  return (
    <>
      <div className={"mb-2"}>
        <div className={"block-title"}>
          Quick Links
        </div>
        <QuickLinkWrapper>
          <PermissionCheck permissionKeys={[entityPermissionName]} permissionOptions={[PermissionOperations.CREATE]}>
            <QuickLinkComponent
              data-testid={`quick-add-team`}
              Modal={AddTeam}
              title="ADD A TEAM"
              text="Add a new team to organization"
            />
          </PermissionCheck>
          <PermissionCheck permissionKeys={[PermissionNames.PERSON]} permissionOptions={[PermissionOperations.CREATE]}>
            <QuickLinkComponent
              data-testid={`quick-add-person`}
              Modal={AddPersonModal}
              title="ADD A PERSON"
              text="Add a new person to organization"
            />
          </PermissionCheck>
          <PermissionCheck permissionKeys={[PermissionNames.VENUE]} permissionOptions={[PermissionOperations.CREATE]}>
            <QuickLinkComponent
              data-testid={`quick-add-venue`}
              Modal={AddVenue}
              title="ADD A VENUE"
              text="Add a new venue to organization"
            />
          </PermissionCheck>
        </QuickLinkWrapper>
        <PermissionCheck permissionKeys={[PermissionNames.SEASON]}>
          <SeasonsList />
        </PermissionCheck>
      </div>
    </>
  );
};

const QuickLinkWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @media only screen and (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

export default Dashboard;
